import {
  Routes as Switch,
  Route,
  NavLink,
  useParams,
} from "react-router-dom";
import AuthLoginPage from "./Auth/auth";
import RefreshLoginPage from "./Auth/refresh";
import { UserRoles } from "./AuthDataProvider";
import { Fragment } from "react";
import Dashboard from "./Dashboard";
import DecryptData from "./ConfigPage/DecryptData";
import DeviceDashboard from "./Device/DeviceDashboard";
import CellTowerMap from "./FleetManagement/CellTowerMap";
import RadioInformation from "./FleetManagement/RadioInformation";
import DomainDashboard from "./Domain/DomainDashboard";
import DomainResult from "./Domain/DomainResult";
import DomainOwnerResult from "./Domain/DomainOwnerResult";
import LoginPage from "./Auth/LoginPage";
import LogoutPage from "./Auth/LogoutPage";
import BokehPopOut from "./BokehPopOut";
import OnlineButNotRegistered from "./FleetManagement/OnlineButNotRegistered";
import BadShuttieReport from "./FleetManagement/BadShuttieReport";
import FleetManagement from "./FleetManagement/FleetManagement";
import UserTeamsReport from "./FleetManagement/UserTeamsReport";
import SimDataUsage from "./FleetManagement/SimDataUsage";
import LogsVsVitals from "./FleetManagement/LogsVsVitals.jsx";
import { AllUsers } from "./ApplicationUsers/AllUsers";
import { User } from "./ApplicationUsers/User";
import LocationResult from "./Location/LocationResult";
import LocationDashboard from "./Location/LocationDashboard";
import FlowieOZero from "./FleetManagement/FlowieOZero";
import FleetStatus from "./FleetManagement/FleetStatus";
import FleetStatusOffline from "./FleetManagement/FleetStatusOffline";
import WaterKernelInit from "./FleetManagement/WaterKernelInit";
import ChargifyShopifyResult from "./ChargifyShopifyLookup/ChargifyShopifyResult";
import ConfigPage from "./ConfigPage/ConfigPage";
import EventSpammersReport from "./FleetManagement/EventSpammersReport";
import WaterKernelUniqueDevices from "./FleetManagement/WaterKernelUniqueDevices";
import ZoneRatioSwitchReport from "./FleetManagement/ZoneRatioSwitchReport";
import SadWaterDevices from "./FleetManagement/SadWaterDevices";
import PrivateRoute from "./PrivateRoute";

const paths = [
  {
    path: "/",
    exact: true,
    main: <Dashboard />,
  },
  {
    path: "/device/:id",
    exact: true,
    main: <DeviceDashboardWrapper />,
  },
  {
    path: "/radio/:id",
    exact: true,
    main: <RadioInformationWrapper />,
  },
  {
    path: "/map/:id",
    exact: true,
    main: <MapWrapper />,
  },
  {
    path: "/bokeh",
    exact: true,
    main: <BokehPopOut />,
  },
  {
    path: "/cfg",
    exact: true,
    main: <ConfigPage />,
  },
  {
    path: "/decoderring",
    exact: true,
    main: <DecryptData />,
  },
  {
    path: "/fleet/communictaing",
    exact: true,
    main: <OnlineButNotRegistered />,
  },
  {
    path: "/fleet",
    exact: true,
    main: <FleetManagement />,
  },
  {
    path: "/fleet/users/report",
    exact: true,
    main: <UserTeamsReport />,
  },
  {
    path: "/fleet/sims/usage",
    exact: true,
    main: <SimDataUsage />,
  },
  {
    path: "/fleet/badshutties/report",
    exact: true,
    main: <BadShuttieReport />,
  },
  {
    path: "/fleet/flowieozero",
    exact: true,
    main: <FlowieOZero />,
  },
  {
    path: "/fleet/fleetstatus",
    exact: true,
    main: <FleetStatus />,
  },
  {
    path: "/fleet/fleetstatus/offline",
    exact: true,
    main: <FleetStatusOffline />,
  },
  {
    path: "/fleet/waterkernelinit",
    exact: true,
    main: <WaterKernelInit />,
  },
  {
    path: "/fleet/waterkernelunique",
    exact: true,
    main: <WaterKernelUniqueDevices />,
  },
  {
    path: "/fleet/eventspammers",
    exact: true,
    main: <EventSpammersReport />,
  },
  {
    path: "/fleet/zoneratioswitch",
    exact: true,
    main: <ZoneRatioSwitchReport />,
  },
  {
    path: "/fleet/sadwaterdevices",
    exact: true,
    main: <SadWaterDevices />,
  },
  {
    path: "/fleet/logsvsvitals",
    exact: true,
    main: <LogsVsVitals />,
  },
  {
    path: "/applicationusers",
    exact: true,
    requiredRoles: [UserRoles.admin],
    main: <AllUsers />,
  },
  {
    path: "/user/:userId",
    exact: true,
    main: <UserWrapper />,
  },
  {
    path: "/domain/:domainId",
    exact: true,
    main: <DomainDashWrapper />,
  },
  {
    path: "/domain/search/:domainId",
    exact: true,
    main: <DomainResultWrapper />,
  },
  {
    path: "/domain/search/owner/:domainId",
    exact: true,
    main: <DomainOwnerResultWrapper />,
  },
  {
    path: "/location/search/:locationId",
    exact: true,
    main: <LocationResultWrapper />,
  },
  {
    path: "/location/dashboard/:locationId",
    exact: true,
    main: <LocationDashboardWrapper />,
  },
  {
    path: "/chargifyshopify/search/:code",
    exact: true,
    main: <ChargifyShopifyResultWrapper />,
  }
];
function DeviceDashboardWrapper() {
  let { id } = useParams();
  return <DeviceDashboard key={id} device={id} />;
}

function RadioInformationWrapper() {
  let { id } = useParams();
  return <RadioInformation coreId={id} />;
}

function UserWrapper() {
  let { userId } = useParams();
  return <User userId={userId} />;
}

function DomainDashWrapper() {
  let { domainId } = useParams();
  return <DomainDashboard domain={domainId} />;
}

function DomainResultWrapper() {
  let { domainId } = useParams();
  return <DomainResult domain={domainId} />;
}

function DomainOwnerResultWrapper() {
  let { domainId } = useParams();
  return <DomainOwnerResult domain={domainId} />;
}

function LocationResultWrapper() {
  let { locationId } = useParams();
  return <LocationResult location={locationId} />;
}

function LocationDashboardWrapper() {
  let { locationId } = useParams();
  return <LocationDashboard location={locationId} />;
}

function ChargifyShopifyResultWrapper() {
  let { code } = useParams();
  return <ChargifyShopifyResult code={code} />;
}

function MapWrapper() {
  let { id } = useParams();
  return (
    <Fragment>
      <CellTowerMap coreId={id} />
      <RadioInformation coreId={id} />
      <NavLink to={"/device/" + id}>Device Details</NavLink>
    </Fragment>
  );
}

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/auth" element={<AuthLoginPage />} />
      <Route exact path="/login" element={<LoginPage />} />
      <Route exact path="/logout" element={<LogoutPage />} />
      <Route exact path="/refresh" element={<RefreshLoginPage />} />
      {paths.map((route, index) => (
        <Route
          key={index + "r"}
          exact
          path={route.path}
          element={<PrivateRoute requiredRoles={route.requiredRoles}/>}
        >
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            element={route.main}
            requiredRoles={route?.requiredRoles}
          />
        </Route>
      ))}
      {/* <PrivateRoute>
        <CantFind />
      </PrivateRoute> */}
    </Switch>
  );
};

export default Routes;